import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import Figure from "@hydrologiq/shared/figures/generic/Figure"
import FigureContent from "@hydrologiq/shared/figures/generic/FigureContent"
import TrendIndicator from "@hydrologiq/shared/figures/generic/TrendIndicator"

interface GeneratorRuntimeFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function GeneratorRuntimeFigure({
  data,
  loading,
  error,
  isPlaceholder,
  compact = true,
}: GeneratorRuntimeFigureProps) {
  const yesterdayPct = data?.value ?? 0
  const trendPct = data?.metadata?.trend_pct as number | undefined
  const dayBeforePct = data?.metadata?.day_before_pct as number | undefined

  // Only show trend if we have day-before data and it's non-zero
  const tooltipText =
    dayBeforePct != null
      ? `Day before ${dayBeforePct}%`
      : undefined

  const trend =
    trendPct != null && trendPct !== 0 && dayBeforePct != null ? (
      <TrendIndicator
        change={trendPct}
        goodDirection="decrease"
        tooltipText={tooltipText}
      />
    ) : undefined

  return (
    <Figure
      heading={data?.label ?? "Generator Runtime"}
      isPlaceholder={!data?.available || error !== undefined || isPlaceholder}
      loading={loading}
      error={error}
      compact={compact}
    >
      <FigureContent.Root compact={compact}>
        <FigureContent.SubText link={trend} compact={compact}>
          yesterday
        </FigureContent.SubText>
        <FigureContent.Value compact={compact}>
          {`${yesterdayPct.toFixed(1)}%`}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default GeneratorRuntimeFigure
